
import {defineAsyncComponent, defineComponent, ref, reactive } from "vue";
import {
  BookFilled,
  FundFilled,
  WalletFilled,
  ReadFilled,
  QuestionCircleFilled,
  EditFilled,HeartFilled,StarFilled
} from "@ant-design/icons-vue";
import { Modal, message,Card,Tabs,TabPane,Rate,Progress,Row,Col } from "ant-design-vue";
import { TimeyyMMddHHmm } from "@/store/guid";
import iArticle from "@/components/home/Article.vue"; // @ is an alias to /src
import iAuthor from "@/components/home/Author.vue"; // @ is an alias to /src
import iQuestion from "@/components/home/Question.vue"; // @ is an alias to /src
import iAowokOneDay from "@/components/home/AowokOneDay.vue"; // @ is an alias to /src"Fre"+Pg+guid16
import { LevelLine,Level,LevelName,UserComDateName,UserClass } from "@/store/purProcess";
import { TimeyyMMdd, Pg,guid4,guid16 } from "@/store/guid";
import { DateGang} from "@/store/formatTime";
import request from "@/api/http";
import router from "@/router";
import store from "@/store";
export default defineComponent({
  name: "LeftHome",
  components: {
    "b-article": iArticle,
    "b-author": iAuthor,
    "b-question": iQuestion,
    "b-aowokOneDay": iAowokOneDay,
    "a-tabs":Tabs,
    "a-tab-pane":TabPane,
    "a-rate":Rate,
    "a-progress":Progress,
    FundFilled,
    WalletFilled,
    ReadFilled,
    QuestionCircleFilled,
    EditFilled,
    BookFilled,
    HeartFilled,
    StarFilled,
  },
  // props: {
  //   userInfo: {
  //     type: Array,
  //     default: "",
  //   },
  // },
  props:['userInfo'],
  setup(props:any) {


    function delteleToken() {
      message.success("已成功退出账户");
      window.localStorage.clear();
      setTimeout(() => {
        window.location.reload()
      }, 1000);
    }
    let leftHomeSt = reactive({
      datatime: TimeyyMMdd(),
      getReadDoor: false,
      time:0,
      letterView:true,
      router:"",
      lockQian:false,
    });
    const userNumber = ref<number>(3);
    const userDesc = ref<string[]>(['terrible', 'bad', 'normal', 'good', 'wonderful']);
    const letterList=[{id:1,url:"GDS30",name:"老年抑郁量表",dp:"简述",lClass:"日常监测",time:"8-20",lei:"判断题",xiang:"2"},{id:2,url:"DISC40",name:"DISC心理性格",dp:"简述",lClass:"自评自测",time:"21-53",lei:"单选题",xiang:"4"},{id:3,url:"EPQ88",name:"艾森克人格问卷",dp:"简述",lClass:"自评自测",time:"23-58",lei:"判断题",xiang:"2"},{id:4,url:"MPS75",name:"马斯诺安全感问卷",dp:"简述",lClass:"自评自测",time:"30-75",lei:"单选题",xiang:"3"},{id:5,url:"RJ28",name:"人际关系综合问卷",dp:"简述",lClass:"自评自测",time:"7-18",lei:"判断题",xiang:"2"},{id:6,url:"TAS26",name:"多伦多述情障碍",dp:"简述",lClass:"心理量表",time:"17-43",lei:"单选题",xiang:"5"},{id:7,url:"AAS18",name:"成人依恋量表",dp:"简述",lClass:"自评自测",time:"12-30",lei:"单选题",xiang:"5"},{id:8,url:"BDl21",name:"Beck抑郁自评问卷",dp:"简述",lClass:"日常监测",time:"11-28",lei:"单选题",xiang:"4"},{id:9,url:"SAS20",name:"焦虑自测量表",dp:"简述",lClass:"日常监测",time:"10-26",lei:"单选题",xiang:"4"},{id:10,url:"YBOCS10",name:"强迫症状量表",dp:"简述",lClass:"日常监测",time:"8-20",lei:"单选题",xiang:"6"},{id:11,url:"SAD28",name:"社交回避及苦恼量表",dp:"简述",lClass:"心理量表",time:"7-18",lei:"单选题",xiang:"2"},{id:12,url:"WLS50",name:"威廉斯创造力倾向量表",dp:"简述",lClass:"心理量表",time:"20-50",lei:"单选题",xiang:"3"},{id:13,url:"SES10",name:"自尊量表量表",dp:"简述",lClass:"心理量表",time:"5-13",lei:"单选题",xiang:"4"},{id:14,url:"FNE30",name:"惧怕否定评价",dp:"简述",lClass:"心理量表",time:"20-50",lei:"单选题",xiang:"5"},{id:15,url:"ZY60",name:"舒伯的职业价值观量表",dp:"简述",lClass:"心理量表",time:"20-50",lei:"单选题",xiang:"5"},{id:16,url:"SI16",name:"安全感测试",dp:"简述",lClass:"日常监测",time:"10-26",lei:"单选题",xiang:"5"},{id:17,url:"DSQ88",name:"心理防御测定问卷",dp:"简述",lClass:"心理量表",time:"35-88",lei:"单选题",xiang:"9"},{id:18,url:"ECR36",name:"人际关系综合诊断量表",dp:"简述",lClass:"心理量表",time:"25-63",lei:"单选题",xiang:"7"},{id:19,url:"SH20",name:"社会适应能力诊断量表",dp:"简述",lClass:"心理量表",time:"8-20",lei:"单选题",xiang:"3"},{id:20,url:"UCLA20",name:"UCLA孤独量表",dp:"简述",lClass:"心理量表",time:"10-26",lei:"单选题",xiang:"4"},{id:21,url:"SDS20",name:"抑郁自评量表",dp:"简述",lClass:"日常监测",time:"10-26",lei:"单选题",xiang:"4"},];
    //获取文章列表
    const aowokArticleList = ref<any>(null);
    let tempStore = store;
    getAowokArticle();
    function getAowokArticle() {
      if (tempStore.state.AowokArticle!) {
        aowokArticleList.value = JSON.parse(tempStore.state.AowokArticle!);
        //console.log(aowokArticleList);
      } else {
        request({
        url: "/HomeAPI/GetOneDayAowokArtList",
        params: {
          pg: Pg(),
        },
      }).then((res: any) => {
        aowokArticleList.value = res.data.response;
        store.commit("saveAowokArticle", JSON.stringify(res.data.response)); //保存 tokenAowokArticle
      });
      }
    };
    //每日签到
    function checkOneDayQian() {
      leftHomeSt.lockQian=true;
      request({
        url: "/UserInfoApi/UpUserInfo",
        method: "post",
        data: {
          data: window.location.href,
          system: "SignIng",
        },
      }).then((res: any) => {
        if (res.data.success) {
          message.success("已完成签到,积分+10");
          setTimeout(() => {
            getMyUserInfo();
          }, 500);
        }
        else {
          message.error(res.data.msg);
          leftHomeSt.lockQian=false;
        }
      });
    }
    function checkDataF5() {
      getMyUserInfo() 
    }
    function getMyUserInfo() {
      request({
        url: "/UserInfoApi/Get",
      }).then((res: any) => {
        store.commit("saveUserInfo", JSON.stringify(res.data.response)); //保存 token
      });
    }

    let userInfoList = ref<any>(null);




    function getUserInfo() {
      if (tempStore.state.userInfo) {
        userInfoList.value = JSON.parse(tempStore.state.userInfo!);
      } else {
      request({
        url: "/HomeAPI/GetUserInfo",
      }).then((res: any) => {
        userInfoList.value = res.data.response;
        store.commit("saveUserInfo", JSON.stringify(res.data.response)); //保存 token
      });
    }
    }

    getUserInfo();
    function gotoPurhome() {
      router.replace("/PurHome");
    }
    function gotoLetter(e:any) {
      window.location.href=e;
    };
    const activeKey = ref('1');
    const userdata = reactive({
      switchReadPointsOpen: true,
      switchShareLearnedOpen: true,
      switchLookMe: true,
      level: 0,
      levelLine: 0,
      userClass: 1,
      userClassName: "注册学员",
      loginResetPassWord: null,
      confirmPassWord: null,
      loginNewPassWord: null,
    });
    const guestId = window.localStorage.getItem('GuestId');
    let userInfo: any = null;
    let userRead = reactive({
      href: "",
      id: "",
      miniToken: "",
      time: "",
      netId: "",
      title: "",
      image:"",
      rehref: "",
      url:window.location.protocol+'//'+window.location.host+"/FCR/Fre"+guestId
    });
    if (props.userInfo) {
      userInfo = props.userInfo;//userInfo.addTime
      userInfo.lookMe == 1
        ? (userdata.switchLookMe = true)
        : (userdata.switchLookMe = false);
      userInfo.readPointsOpen == 1
        ? (userdata.switchReadPointsOpen = true)
        : (userdata.switchReadPointsOpen = false);
      userInfo.shareLearnedOpen == 1
        ? (userdata.switchShareLearnedOpen = true)
        : (userdata.switchShareLearnedOpen = false);
    }
    //1分钟循环获取
    const Return60CountDown = () => {
      if (leftHomeSt.time > 0) {
        leftHomeSt.time--;
        setTimeout(Return60CountDown, 1000);
        leftHomeSt.getReadDoor = true;
      }
      else {
        leftHomeSt.time = 10;
        message.warning("刷新1次");
        GetReadUserData();
        leftHomeSt.getReadDoor = false;
      }
    }
    function GetRouter() {
      let id=router.currentRoute.value.fullPath
      leftHomeSt.router=id;
      if(id.includes('Letter')){//匹配字符中有的内容
        leftHomeSt.letterView=false;
      }
    };
    GetRouter();
    function GetReadUserData() {
      if(userInfo!){
        request({
        url: "/UserInfoApi/GetReadUserData",
      }).then((res: any) => {
        if (res.data.success == true) {
          var a = res.data.response.split(","); //保存 token
          userRead.miniToken = a[0].toString();
          userRead.time = a[1];
          userRead.href = window.location.href;
          userRead.rehref = window.location.pathname+window.location.search ;
          userRead.id = "0";
          userRead.netId = guid4() + TimeyyMMdd() + guid4();
          store.commit("saveUserRead", JSON.stringify(userRead)); //保存 tokenurlId+"#"+
          // ////console.log(userRead.miniToken);
        }
        else if(res.data.status == 401||res.data.status == 404){
          message.info("账号在其他地方登录，或登录超时，请重新登录");
          window.localStorage.clear();
          window.location.reload();
          router.replace("/login");
        }
      })
      .catch(function (err: any) {
        message.info("账号在其他地方登录，或登录超时，请重新登录");
        window.localStorage.clear();
        window.location.reload();
        router.replace("/login");
        });
      }
      
    }
    // }
    GetReadUserData();
    return {
      store,
      letterList,
      activeKey,
      userNumber,
      userDesc,
      leftHomeSt,
      userInfoList,
      userInfo,
      checkOneDayQian,
      aowokArticleList,
      gotoPurhome,
      userdata,
      delteleToken,
      TimeyyMMddHHmm,
      LevelLine,
      Level,LevelName,
      UserComDateName,
      UserClass,
      gotoLetter,
      userRead,
      props,
      DateGang,
      checkDataF5,
      guid16,
      Pg,
    };
  },
});
